import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let redirecting = false;
api.interceptors.response.use((r) => r, (e) => {
  const url = e?.config?.url || "";
  const onPublic = ["/login", "/reset-password", "/forgot-password"].some((p) => window.location.pathname.startsWith(p));
  if (e?.response?.status === 401 && !url.startsWith("/auth/") && !onPublic && !redirecting) {
    redirecting = true;
    window.location.assign(`/login?expired=1&next=${encodeURIComponent(window.location.pathname + window.location.search)}`);
  }
  return Promise.reject(e);
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (e?.response?.status === 401) return "Your session has ended. Please sign in again.";
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const reportClientEvent = (type) => {
  api.post("/security/client-event", { type, path: window.location.pathname }).catch(() => {});
};
